<footer>
  <div class="logo-container" *ngIf="brokerId == '01'">
    <img src="../../../../../assets/images/chill-logo-purple.svg" alt="" srcset="" />

    <span>
      <!-- TrustBox widget -->
      <!-- <div class="trustpilot-widget" data-locale="en-GB" data-template-id="539ad60defb9600b94d7df2c" data-businessunit-id="57eb89ea0000ff0005954a7d" data-style-height="100px" data-style-width="100%" data-theme="light" data-stars="3,4,5" data-schema-type="Organization">
        <a href="https://uk.trustpilot.com/review/chill.ie" target="_blank" rel="noopener">Trustpilot</a>
      </div> -->
      <!-- End TrustBox widget -->
      <!-- TrustBox widget - Micro Star -->
      <div class="trustpilot-widget" data-locale="en-IE" data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id="57eb89ea0000ff0005954a7d" data-style-height="24px" data-style-width="100%"
        data-theme="light"> <a href="https://ie.trustpilot.com/review/chill.ie" target="_blank"
          rel="noopener">Trustpilot</a> </div> <!-- End TrustBox widget -->
    </span>
  </div>
  <hr *ngIf="brokerId == '01'" />
  <div class="copyright-container" *ngIf="brokerId == '01'">
    <span>Copyright &copy; Chill Insurance. All Rights Reserved. Chill Insurance Ltd,
      Chill Insurance is regulated by the Central Bank of Ireland. Registered
      number 506021.Registered in Republic of Ireland. <a href="{{broker.termsOfBusinessUrl}}" target="_blank">Terms of
        Business</a>,
      <a href="{{broker.privacyPolicyUrl}}" target="_blank">Privacy Policy</a>, <a href="{{journeyGuideUrl}}"
        target="_blank">Quote Journey Guide</a>.</span>

    <!-- OneTrust Cookies Settings button start -->
    <button matRipple [matRippleCentered]="true" [matRippleDisabled]="false" [matRippleUnbounded]="false"
      id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
    <!-- OneTrust Cookies Settings button end -->

  </div>

  <div class="copyright-container-qd" *ngIf="brokerId == '04'">
    <span>Copyright &copy; Quote Devil Insurance. All Rights Reserved. Quote Devil Insurance Ltd. t/a Quote Devil
      Insurance is regulated by the Central Bank of Ireland. Registered number 430291. Registered in the Republic of
      Ireland. <a href="{{broker.termsOfBusinessUrl}}" target="_blank">Terms of Business</a>. <a
        href="{{broker.privacyPolicyUrl}}" target="_blank">Privacy
        Policy</a>, <a href="{{journeyGuideUrl}}" target="_blank">Quote Journey Guide</a>.</span>

    <!-- OneTrust cookies settings button start -->

    <button id="ot-sdk-btn" class=" qd ot-sdk-show-settings">Cookie settings</button>

    <!-- OneTrust cookies settings button end -->
  </div>
</footer>
